/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { DegreeModel, DegreeNameModel, MajorModel } from '../../../../app/modules/auth';
import { getAllDegreeNames, getAllMajors, getAllStaffType } from '../../../../app/modules/auth/core/_api';
import { KTSVG } from '../../../helpers'

const SidebarStaffType: FC = () => {
    const [articleDegreeNames, setArticleDegreeNames] = useState<DegreeModel[]>()

    useEffect(() => {
        async function updateDegreeName() {
            const degrees = await getAllStaffType()
            var degree_arr = new Array<DegreeModel>()
            degrees.data.degrees.forEach((degree: DegreeModel) => {
                degree_arr.push(degree)
            });
            setArticleDegreeNames(degree_arr)
        };
        updateDegreeName();
    }, []);

    return (
        <div className='card bg-light mb-2 mb-lg-10 shadow-none border-0'>
            <div className='card-header align-items-center border-0'>
                <h3 className='card-title fw-bolder text-gray-900 fs-3'>ผลงานตามประเภทบุคลากร</h3>
            </div>

            <div className='card-body pt-0'>
                {articleDegreeNames && articleDegreeNames.map((item, i) => {
                    return (
                        <div className={`d-flex mb-2`} key={i}>
                            <KTSVG
                                path='/media/icons/duotune/general/gen057.svg'
                                className='svg-icon-2 mt-0 me-2'
                            />

                            <Link
                                to={`/home?sid=${item.id}&staff=${item.degree_name}`}
                                className='text-gray-700 text-hover-primary fs-6 '
                            >
                                {item.degree_name}
                            </Link>
                        </div>
                    )
                })}

                <div className={`d-flex: mb-2`}>
                    <KTSVG
                        path='/media/icons/duotune/general/gen057.svg'
                        className='svg-icon-2 mt-0 me-2'
                    />

                    <Link
                        to={`/home?sid=teacher&staff=อาจารย์`}
                        className='text-gray-700 text-hover-primary fs-6 '
                    >
                        อาจารย์
                    </Link>
                </div>

                <div className={`d-flex: mb-2`}>
                    <KTSVG
                        path='/media/icons/duotune/general/gen057.svg'
                        className='svg-icon-2 mt-0 me-2'
                    />

                    <Link
                        to={`/home?sid=staff&staff=สายสนับสนุน`}
                        className='text-gray-700 text-hover-primary fs-6 '
                    >
                        สายสนับสนุน
                    </Link>
                </div>

            </div>
        </div>
    )
}

export { SidebarStaffType }
